import { createSlice } from '@reduxjs/toolkit';
import { createAsyncAction } from '../action';

const getDashboardData = createAsyncAction('getDashboardData', 'getDashboardData');

interface DashboardData {
  candidate_count: number;
  candidate_appointment_requested_count: number;
  candidate_not_scheduled_count: number;
  candidate_scheduled_count: number;
  candidate_reports_pending_count: number;
  candidate_done_count: number;

  candidate_expired_count: number;
  candidate_expired_scheduled_count: number;
  candidate_expiring_count: number;
  candidate_expiring_scheduled_count: number;

  candidate_this_month_appointment_requested_count: number;
  candidate_this_month_count: number;
  candidate_this_month_done_count: number;
  candidate_this_month_not_scheduled_count: number;
  candidate_this_month_reports_pending_count: number;
  candidate_this_month_scheduled_count: number;
}

interface IInitialState {
  dashboardData: DashboardData;
  isFetchingDashboardData: boolean;
}

const initialState = {
  dashboardData: {
    candidate_appointment_requested_count: 0,
    candidate_count: 0,
    candidate_done_count: 0,
    candidate_expired_count: 0,
    candidate_expired_scheduled_count: 0,
    candidate_expiring_count: 0,
    candidate_expiring_scheduled_count: 0,
    candidate_not_scheduled_count: 0,
    candidate_reports_pending_count: 0,
    candidate_scheduled_count: 0,
    candidate_this_month_appointment_requested_count: 0,
    candidate_this_month_count: 0,
    candidate_this_month_done_count: 0,
    candidate_this_month_not_scheduled_count: 0,
    candidate_this_month_reports_pending_count: 0,
    candidate_this_month_scheduled_count: 0,
  },

  isFetchingDashboardData: false,
} as IInitialState;

export const counterSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    updateDashboardState: (state, action) => Object.assign(state, action.payload),
  },
  extraReducers: {
    [getDashboardData.pending as any]: (state) => {
      state.isFetchingDashboardData = true;
    },
    [getDashboardData.fulfilled as any]: (state, { payload }) => {
      console.log('fulfilled request', payload);
      state.isFetchingDashboardData = false;
      state.dashboardData = payload.data || {};
    },
    [getDashboardData.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isFetchingDashboardData = false;
      }
    },
  },
});

const { updateDashboardState } = counterSlice.actions;
export {
  updateDashboardState,
  getDashboardData,
};
export default counterSlice.reducer;
